var map = {
	"./BEAMBASIC/Beam SF_Step48.png": "a328",
	"./BEAMBASIC/En-T600.gif": "ac7c",
	"./BEAMBASIC/Picture1.png": "4ad8",
	"./BEAMBASIC/Picture10.png": "c5f4",
	"./BEAMBASIC/Picture11.png": "b0f3",
	"./BEAMBASIC/Picture12.png": "f779",
	"./BEAMBASIC/Picture2.png": "577b",
	"./BEAMBASIC/Picture3.png": "50cf",
	"./BEAMBASIC/Picture4.png": "3cb0",
	"./BEAMBASIC/Picture44.png": "0eda",
	"./BEAMBASIC/Picture5.png": "afc5",
	"./BEAMBASIC/Picture6.png": "d697",
	"./BEAMBASIC/Picture7.png": "db57",
	"./BEAMBASIC/Picture8.png": "9fbf",
	"./BEAMBASIC/Picture9.png": "4f4c",
	"./BEAMBASIC/Step_3_Sustain_T850.png": "3017",
	"./BEAMBASIC/cover_T850.png": "4774",
	"./BEAMBASIC/desktop.ini": "8e7e",
	"./BEAMBASIC/download.png": "b7fa",
	"./BEAMBASIC/icono_3_people.png": "ca62",
	"./BEAMBASIC/link_beampower.png": "0b70",
	"./BEAMBASIC/step01_a_stand_basic_remove_film_cut_straps.jpg": "ff56",
	"./BEAMBASIC/step01_a_stand_basic_remove_film_cut_straps.png": "250f",
	"./BEAMBASIC/step01_b_stand_basic_open_box-talaria.png": "9d5d",
	"./BEAMBASIC/step01_b_stand_basic_open_box.png": "1619",
	"./BEAMBASIC/step02_a_stand_basic_position_both_feet.png": "31ed",
	"./BEAMBASIC/step03_01_stand_basic_lebel.png": "fbe4",
	"./BEAMBASIC/step03_02_locate_elements.png": "7aa9",
	"./BEAMBASIC/step03_02_locate_elements.tif": "b15b",
	"./BEAMBASIC/step03_a_stand_basic_left_front_leg.png": "76ee",
	"./BEAMBASIC/step03_b_stand_basic_left_rear_leg.png": "de3f",
	"./BEAMBASIC/step03_c_stand_basic_left_screws.png": "93d0",
	"./BEAMBASIC/step04_a_stand_basic_right_front_leg.png": "7100",
	"./BEAMBASIC/step04_b_stand_basic_right_rear_leg.png": "9308",
	"./BEAMBASIC/step04_c_stand_basic_right_screws.png": "328b",
	"./BEAMBASIC/step05_a_stand_basic_right_bottom_cross.png": "8f89",
	"./BEAMBASIC/step05_b_stand_basic_right_bottom_cross_fix_screws.png": "038f",
	"./BEAMBASIC/step05d__stand_power_bottom_cross - Cop1.png": "9986",
	"./BEAMBASIC/step05d__stand_power_bottom_cross.png": "b7c0",
	"./BEAMBASIC/step06_a_stand_basic_left_bottom_cross.png": "fc30",
	"./BEAMBASIC/step06_a_stand_basic_left_bottom_cross_Juliol2023.png": "6d9b",
	"./BEAMBASIC/step06_b_stand_basic_left_bottom_cross_fix_screws.png": "68d0",
	"./BEAMBASIC/step07_a_stand_basic_lock_wheels.png": "6e22",
	"./BEAMBASIC/step08_c_basket_basic_insert_rear_cross.png": "259d",
	"./BEAMBASIC/step09_a_basket_basic_connect_left_right_brackets.png": "fd0f",
	"./BEAMBASIC/step09_a_basket_basic_connect_left_right_brackets_Juliol2023.png": "db58",
	"./BEAMBASIC/step10_a_basket_basic_fix_cross_bracket_screws.png": "2bbb",
	"./BEAMBASIC/step11_a_basket_basic_fix_rear_cross_with_two_screws.png": "838e",
	"./BEAMBASIC/step12_a_basket_basic_clip_tubes.png": "5618",
	"./BEAMBASIC/step12_b_basket_basic_clip_tubes.png": "7051",
	"./BEAMBASIC/step13a_remove_top_cross_beam.png": "c67f",
	"./BEAMBASIC/step14_a_basket_basic_connect_top_cross_to_stand.png": "c1ad",
	"./BEAMBASIC/step15_a_basket_basic_fix_top_cross_to_stand_screws.png": "3e95",
	"./BEAMBASIC/step15_b_basket_basic_fix_top_cross_to_stand_screws.png": "4e7c",
	"./BEAMBASIC/step16_a_remove_tray_and_box-talaria.png": "97d5",
	"./BEAMBASIC/step16_a_remove_tray_and_box.png": "cc38",
	"./BEAMBASIC/step17_a_remove_endcaps-talaria.png": "3429",
	"./BEAMBASIC/step17_a_remove_endcaps.png": "7ce5",
	"./BEAMBASIC/step17_b_tear_the_plastic.png": "0020",
	"./BEAMBASIC/step18_a_printer_basic_place_on_stand.png": "dd65",
	"./BEAMBASIC/step19_a_printer_basic_fix_screws.png": "8a49",
	"./BEAMBASIC/step19_b_printer_basic_fix_screws.png": "5670",
	"./BEAMBASIC/step2.png": "78cc",
	"./BEAMBASIC/step20_1_mfp_locate_refeed_preventers.png": "c2a4",
	"./BEAMBASIC/step20_2_mfp_slide_refeed_preventers.png": "3230",
	"./BEAMBASIC/step20_a_printer_basic_remove_tapes.png": "b528",
	"./BEAMBASIC/step20_b_printer_basic_remove_tapes.png": "7a25",
	"./BEAMBASIC/step21_a_printer_basic_open_roll_cover_remove_tapes.png": "d966",
	"./BEAMBASIC/step21_b_printer_basic_remove_retainers_close_roll_cover.png": "b044",
	"./BEAMBASIC/step22_a_printer_basic_open_main_door_remove_pins.png": "ab22",
	"./BEAMBASIC/step23_a_printer_basic_remove_foam.png": "596f",
	"./BEAMBASIC/step26_a_printer_basic_install_left_rear_cover.png": "00e3",
	"./BEAMBASIC/step27_a_printer_basic_install_multi_sheet_tray.png": "0b29",
	"./BEAMBASIC/step28_withe_lebel.png": "7cb8",
	"./BEAMBASIC/step29_switch_beam_basic-edit-1.png": "44c7",
	"./BEAMBASIC/step31_lift_printer_lowest.png": "aecb",
	"./BEAMBASIC/step32_3-people.png": "14d0",
	"./BEAMBASIC/step40.png": "44cf",
	"./BEAMBASIC/step40_a_remove_tray_and_box.png": "bb32",
	"./BEAMBASIC/step41_a_remove_endcaps.png": "1d7f",
	"./BEAMBASIC/step41_a_switch_on_the_printer.png": "bff9",
	"./BEAMBASIC/step42_a_printer_power_connect_power_lan_cable.png": "a514",
	"./BEAMBASIC/step42_a_tear_the_plastic.png": "6c7d",
	"./BEAMBASIC/step43.png": "439d",
	"./BEAMBASIC/step58_a_virtual_agent.png": "86c3",
	"./BEAMBASIC/step_45_white_lebel.png": "db6a",
	"./BEAMBASIC/white.png": "8326",
	"./BEAMPOWER/00_portada_power.png": "e280",
	"./BEAMPOWER/15.png": "5d21",
	"./BEAMPOWER/21.png": "3f26",
	"./BEAMPOWER/9.png": "2cb4",
	"./BEAMPOWER/Beam SF_Step48.png": "0942",
	"./BEAMPOWER/HP DesignJet T950 STD-Front Human v1a.png": "9bab",
	"./BEAMPOWER/Image20230731162751.png": "8f25",
	"./BEAMPOWER/Image20230731162802.png": "01e9",
	"./BEAMPOWER/Image20230811133042.png": "1a73",
	"./BEAMPOWER/Image202308111330422.png": "460d",
	"./BEAMPOWER/Picture1.png": "5d0b",
	"./BEAMPOWER/Picture10.png": "64ea",
	"./BEAMPOWER/Picture11.png": "612e",
	"./BEAMPOWER/Picture12.png": "cdbf",
	"./BEAMPOWER/Picture13.png": "620d",
	"./BEAMPOWER/Picture14.png": "934b",
	"./BEAMPOWER/Picture15.png": "2c82",
	"./BEAMPOWER/Picture16.png": "49f5",
	"./BEAMPOWER/Picture17.png": "7035",
	"./BEAMPOWER/Picture18.png": "bdc3",
	"./BEAMPOWER/Picture19.png": "1f6a",
	"./BEAMPOWER/Picture22.png": "97f2",
	"./BEAMPOWER/Picture23.png": "58f7",
	"./BEAMPOWER/Picture24.png": "2e11",
	"./BEAMPOWER/Picture25.png": "a825",
	"./BEAMPOWER/Picture26.png": "bf42",
	"./BEAMPOWER/Picture27.png": "1e23",
	"./BEAMPOWER/Picture28.png": "27c4",
	"./BEAMPOWER/Picture29.png": "e849",
	"./BEAMPOWER/Picture30.png": "a56c",
	"./BEAMPOWER/Picture31.png": "cdc7",
	"./BEAMPOWER/VA_logo.png": "10c6",
	"./BEAMPOWER/Virtual Assistant T950.png": "bf96",
	"./BEAMPOWER/cover_T950.png": "cc67",
	"./BEAMPOWER/crate_contents_power.png": "0b42",
	"./BEAMPOWER/icono_3_people.png": "98b8",
	"./BEAMPOWER/link_beampower.png": "60f1",
	"./BEAMPOWER/pull_out_basket_fabrik.png": "3b5a",
	"./BEAMPOWER/remove_the_2_bottom2.png": "13a2",
	"./BEAMPOWER/remove_the_endcaps_2.png": "9015",
	"./BEAMPOWER/remove_the_two_bottom.jpg": "025b",
	"./BEAMPOWER/remove_tray_and_box2.png": "4d9c",
	"./BEAMPOWER/removeandslot.png": "94a1",
	"./BEAMPOWER/slot_slide_blockers.png": "a96f",
	"./BEAMPOWER/step01_a_stand_basic_remove_film_cut_straps.png": "a71e",
	"./BEAMPOWER/step01_a_stand_power_remove_film_cut_straps - Copy.png": "53b2",
	"./BEAMPOWER/step01_a_stand_power_remove_film_cut_straps.png": "85e1",
	"./BEAMPOWER/step01_b_stand_basic_open_box.png": "08a9",
	"./BEAMPOWER/step01_b_stand_power_open_box - Copy.png": "a652",
	"./BEAMPOWER/step01_b_stand_power_open_box.png": "36d8",
	"./BEAMPOWER/step01_c_locate_elements.png": "97a0",
	"./BEAMPOWER/step02_a_stand_power_position_both_feet.png": "22e0",
	"./BEAMPOWER/step03_01_stand_basic_lebel.png": "ba7a",
	"./BEAMPOWER/step04_a_stand_power_left_front_leg - Copy.png": "8a6a",
	"./BEAMPOWER/step04_a_stand_power_left_front_leg.png": "0396",
	"./BEAMPOWER/step04_b_stand_power_left_rear_leg.png": "ea2f",
	"./BEAMPOWER/step04_c_stand_power_left_screws.png": "7300",
	"./BEAMPOWER/step05_a_stand_power_right_front_leg.png": "cbda",
	"./BEAMPOWER/step05_b_stand_power_right_rear_leg.png": "c3ff",
	"./BEAMPOWER/step05_c_stand_power_right_screws.png": "cb52",
	"./BEAMPOWER/step05d__stand_power_bottom_cross - Cop1.png": "3069",
	"./BEAMPOWER/step05d__stand_power_bottom_cross.png": "3646",
	"./BEAMPOWER/step06_a_stand_basic_left_bottom_cross.png": "b908",
	"./BEAMPOWER/step06_a_stand_power_bottom_cross.png": "925e",
	"./BEAMPOWER/step06_b_stand_basic_left_bottom_cross_fix_screws.png": "c738",
	"./BEAMPOWER/step06_b_stand_power_bottom_cross.png": "8564",
	"./BEAMPOWER/step07_a_stand_power_bottom_cross_fix_screws.png": "dbea",
	"./BEAMPOWER/step07_b_insert_bottom_cross_into_right_bottom_connector.png": "9d7e",
	"./BEAMPOWER/step07_b_insert_bottom_cross_into_right_bottom_connector_Julio2023.png": "aba7",
	"./BEAMPOWER/step07_c_stand_power_bottom_cross_fix_screws_right_foot.png": "1238",
	"./BEAMPOWER/step08_a_stand_power_identify_brackets_rear_cross.png": "00d1",
	"./BEAMPOWER/step09_a_basket_power_connect_left_right_brackets.png": "827b",
	"./BEAMPOWER/step09_a_basket_power_connect_left_right_brackets_Juliol2023.png": "016e",
	"./BEAMPOWER/step10_a_stand_power_rotate_stand_lock_wheels.png": "f1f7",
	"./BEAMPOWER/step12_a_stand_power_on_the_floor.png": "1bcd",
	"./BEAMPOWER/step13_a_stand_power_connect_top_cross.png": "e257",
	"./BEAMPOWER/step14_a_stand_power_fix_top_cross.png": "f455",
	"./BEAMPOWER/step15_a_stand_power_lock_wheels.png": "009a",
	"./BEAMPOWER/step16_a_stand_power_remove_stacker_supports.png": "dd59",
	"./BEAMPOWER/step17_a_stand_power_remove_plastic_bag_from_stacker_tray-optionb.png": "c304",
	"./BEAMPOWER/step18_a_stand_power_install_stacker_supports.png": "f3cb",
	"./BEAMPOWER/step19_a-b_failed_stacker-support.png": "5cf4",
	"./BEAMPOWER/step19_a_stand_power_fix_stacker_supports.png": "df45",
	"./BEAMPOWER/step19_b_remove_left-right_stacker_adaptor-box.png": "237a",
	"./BEAMPOWER/step20_1_mfp_locate_refeed_preventers.png": "711b",
	"./BEAMPOWER/step20_2_mfp_slide_refeed_preventers.png": "b8da",
	"./BEAMPOWER/step20_a_stand_power_install_and_fix_left_adaptor.png": "7e6a",
	"./BEAMPOWER/step20_b_printer_basic_remove_tapes.png": "f7c7",
	"./BEAMPOWER/step21_a_printer_basic_open_roll_cover_remove_tapes.png": "d4a1",
	"./BEAMPOWER/step21_a_stand_power_install_and_fix_right_adaptor.png": "18a0",
	"./BEAMPOWER/step21_b_printer_basic_remove_retainers_close_roll_cover.png": "0bdd",
	"./BEAMPOWER/step22_a_printer_basic_open_main_door_remove_pins.png": "dfe3",
	"./BEAMPOWER/step22_a_remove stacker supports.png": "e293",
	"./BEAMPOWER/step22_a_stand_power_remove_stacker_tray.png": "1f10",
	"./BEAMPOWER/step22_a_stand_power_remove_stacker_tray_Julio2023.png": "0150",
	"./BEAMPOWER/step23_a_printer_basic_remove_foam.png": "1d57",
	"./BEAMPOWER/step23_a_remove_plastic_from_supports.png": "d597",
	"./BEAMPOWER/step23_a_stand_power_insert_stacker_tray.png": "7158",
	"./BEAMPOWER/step23_a_stand_power_insert_stacker_tray.tif": "7520",
	"./BEAMPOWER/step24_a_install supports.png": "1f53",
	"./BEAMPOWER/step24_a_printer_basic_connect_power_lan_cable.png": "02e9",
	"./BEAMPOWER/step24_open_cover_stacker_tray.png": "a375",
	"./BEAMPOWER/step25_a_install supports.png": "7d06",
	"./BEAMPOWER/step25_a_stand_power_pull_out_basket_fabric_open_velcro.png": "2991",
	"./BEAMPOWER/step25_printer_basic_route_cables.png": "837e",
	"./BEAMPOWER/step26_a_printer_basic_install_left_rear_cover.png": "2218",
	"./BEAMPOWER/step26_a_remove_stacker_adapters.png": "7590",
	"./BEAMPOWER/step26_a_stand_power_attach_basket_with_velcro.png": "da7b",
	"./BEAMPOWER/step27_a_install_left_adapter.png": "86a8",
	"./BEAMPOWER/step27_a_stand_power_remove_stacket_pocket_slot_it.png": "c2b1",
	"./BEAMPOWER/step27_b_remove_4_stacker_support_adaptors.png": "8988",
	"./BEAMPOWER/step28_a_install_right_adapter.png": "517c",
	"./BEAMPOWER/step28_a_stand_power_stacker_pocket_fits.png": "6e4e",
	"./BEAMPOWER/step29_a_remove_tray.png": "e1bf",
	"./BEAMPOWER/step29_a_stand_power_slot_blockers.png": "0ce0",
	"./BEAMPOWER/step2_a_remove_bottom_conectors - Copy.png": "4660",
	"./BEAMPOWER/step2_a_remove_bottom_conectors.png": "f588",
	"./BEAMPOWER/step30_a_install_tray.png": "34c9",
	"./BEAMPOWER/step30_a_stand_power_stacker_inser_bars.png": "0b8e",
	"./BEAMPOWER/step30_b_stand_power_stacker_assembled.png": "da40",
	"./BEAMPOWER/step31_a_remove packaging.png": "4e33",
	"./BEAMPOWER/step31_a_remove_tray_and_box - Copy.png": "a16a",
	"./BEAMPOWER/step32_a_printer_power_open_endcap - Copy.png": "e91a",
	"./BEAMPOWER/step32_a_pull_out_fabric.png": "aedc",
	"./BEAMPOWER/step32_b_printer_power_remove_endcaps - Copy.png": "5d4b",
	"./BEAMPOWER/step33_a_printer_power_uncover_printer - Copy.png": "8c2e",
	"./BEAMPOWER/step33_a_pull_out_fabric.png": "319b",
	"./BEAMPOWER/step33b_finger-stacker-hold - Copy.png": "cb68",
	"./BEAMPOWER/step34_a_printer_power_place_printer - Copy.png": "c78a",
	"./BEAMPOWER/step34_a_put_the_pocket.png": "d516",
	"./BEAMPOWER/step35_a_printer_power_fix_printer_right_side - Copy.png": "f15a",
	"./BEAMPOWER/step35_a_printer_power_fix_printer_right_side - Copy.tif": "88ce",
	"./BEAMPOWER/step35_a_put_the_pocket.png": "c72a",
	"./BEAMPOWER/step35_b_printer_power_fix_printer_left_side - Copy.png": "8a01",
	"./BEAMPOWER/step35_b_printer_power_fix_printer_left_side - Copy.tif": "b177",
	"./BEAMPOWER/step36_a_connect_side_blockers.png": "4c70",
	"./BEAMPOWER/step36_a_printer_power_install_U_frame - Copy.png": "5a03",
	"./BEAMPOWER/step37_1_mfp_locate_refeed_preventers - Copy.png": "0bbb",
	"./BEAMPOWER/step37_2_mfp_slide_refeed_preventers - Copy.png": "684b",
	"./BEAMPOWER/step37_a_connect_side_blockers.png": "7fc9",
	"./BEAMPOWER/step37_a_printer_power_remove_tapes - Copy.png": "4868",
	"./BEAMPOWER/step37_b_printer_power_desiccant_bags - Copy.png": "aaf3",
	"./BEAMPOWER/step38_a_lift_the_stacker.png": "d0a4",
	"./BEAMPOWER/step38_a_printer_power_open_roll_cover_remove_tapes_retainers - Copy.png": "8a06",
	"./BEAMPOWER/step38_b_printer_power_remove_retainers_close_roll_cover.png": "43f6",
	"./BEAMPOWER/step39_a_printer_power_open_main_door_remove_pins.png": "cc77",
	"./BEAMPOWER/step39_a_stacker_final.png": "accd",
	"./BEAMPOWER/step3_a_locate components - Copy.png": "174e",
	"./BEAMPOWER/step3_a_locate components.png": "05df",
	"./BEAMPOWER/step40_a_printer_power_remove_foam.png": "ad9e",
	"./BEAMPOWER/step40_a_remove tray_and_box.png": "d067",
	"./BEAMPOWER/step40_a_remove_tray_and_box.png": "7d6e",
	"./BEAMPOWER/step41_a_remove_endcaps.png": "164e",
	"./BEAMPOWER/step41_b_printer_power_open_multisheet_tray_remove_tapes.png": "830f",
	"./BEAMPOWER/step42_a_printer_power_connect_power_lan_cable.png": "4e70",
	"./BEAMPOWER/step42_a_tea_the_plastic.png": "74ee",
	"./BEAMPOWER/step42_a_tear_the_plastic.png": "c39e",
	"./BEAMPOWER/step43_a_printer_basic_place_on_stand.png": "a83e",
	"./BEAMPOWER/step43_a_printer_power_route_cables.png": "5d23",
	"./BEAMPOWER/step44_a_printer_basic_fix_screws.png": "59a7",
	"./BEAMPOWER/step44_a_printer_power_install_cable_cover.png": "e2ac",
	"./BEAMPOWER/step45_b_printer_basic_fix_screws.png": "57d9",
	"./BEAMPOWER/step45_withe_lebel.png": "6c23",
	"./BEAMPOWER/step46_a_lift_printer_lowest (1).png": "65c6",
	"./BEAMPOWER/step46_a_lift_printer_lowest.png": "43e6",
	"./BEAMPOWER/step46_a_lift_printer_lowest.tif": "b76f",
	"./BEAMPOWER/step46_install_U_frame.png": "a50a",
	"./BEAMPOWER/step46_switch_beam_power-edit-1.png": "d5cc",
	"./BEAMPOWER/step47_3-people.png": "4ae6",
	"./BEAMPOWER/step47_a_printer_basic_remove_tapes.png": "170f",
	"./BEAMPOWER/step48_b_printer_basic_remove_tapes.png": "f7e1",
	"./BEAMPOWER/step49_b_printer_basic_remove_tapes.png": "45b7",
	"./BEAMPOWER/step50_b_printer_basic_remove_retainers_close_roll_cover.png": "a94d",
	"./BEAMPOWER/step51_a_printer_basic_open_main_door_remove_pins.png": "95dc",
	"./BEAMPOWER/step52_a_printer_basic_remove_foam.png": "e126",
	"./BEAMPOWER/step53_a_printer_power_remove_packaging.png": "e83a",
	"./BEAMPOWER/step54_a_printer_basic_connect_power_lan_cable.png": "9d00",
	"./BEAMPOWER/step55_a_route_cables.png": "4fe7",
	"./BEAMPOWER/step56_a_printer_basic_install_left_rear_cover.png": "0b59",
	"./BEAMPOWER/step57_a_switch_on_the_printer.png": "3d68",
	"./BEAMPOWER/step58_a_virtual_agent.png": "bdcd",
	"./BEAMPOWER/step_45_white_lebel.png": "69e9",
	"./BEAMPOWER/switch_on2.png": "35c0",
	"./BEAMPOWER/tear_tha_plasticbag2.png": "c4e0",
	"./BEAMPOWER/two_people.svg": "45fb",
	"./BEAMPOWER/white.png": "0d15",
	"./Doer/01.png": "3853",
	"./Doer/02.png": "1a92",
	"./Doer/03.png": "e608",
	"./Doer/04.png": "4ba9",
	"./Doer/04_old.png": "998c",
	"./Doer/05.png": "1fb0",
	"./Doer/06.png": "eea5",
	"./Doer/07.png": "4168",
	"./Doer/08.png": "f54b",
	"./Doer/09.png": "df05",
	"./Doer/10.png": "f0c6",
	"./Doer/11.png": "8999",
	"./Doer/12.png": "ebe9",
	"./Doer/13.png": "4073",
	"./Doer/BASKET-547.png": "de10",
	"./Doer/BASKET_572.png": "b2ed",
	"./Doer/VA_logo.png": "cf43",
	"./Doer/doer.png": "7818",
	"./Doer/end_screen.png": "898e",
	"./Doer/printer.png": "bf1f",
	"./Doer/two_people.svg": "f806",
	"./DoerEcoSpark/01.png": "dc74",
	"./DoerEcoSpark/01_NEW.png": "6cd8",
	"./DoerEcoSpark/02.png": "7040",
	"./DoerEcoSpark/03.png": "6e1e",
	"./DoerEcoSpark/04.png": "c023",
	"./DoerEcoSpark/04_old.png": "8192",
	"./DoerEcoSpark/05.png": "fb27",
	"./DoerEcoSpark/06.png": "56f9",
	"./DoerEcoSpark/07.png": "52dd",
	"./DoerEcoSpark/08.png": "fb14",
	"./DoerEcoSpark/09.png": "ff20",
	"./DoerEcoSpark/09_2.png": "adc0",
	"./DoerEcoSpark/10.png": "22ef",
	"./DoerEcoSpark/11.png": "7d36",
	"./DoerEcoSpark/12.png": "0ec9",
	"./DoerEcoSpark/13.png": "482f",
	"./DoerEcoSpark/BASKET-547.png": "f438",
	"./DoerEcoSpark/BASKET_572.png": "cad2",
	"./DoerEcoSpark/OneDrive - Capgemini - Shortcut.lnk": "5b4a",
	"./DoerEcoSpark/VA_logo.png": "86a0",
	"./DoerEcoSpark/doer.png": "8c1f",
	"./DoerEcoSpark/end_screen.png": "e029",
	"./DoerEcoSpark/printer.png": "ae51",
	"./DoerEcoSpark/two_people.svg": "3244",
	"./HPlogo-light-XL.svg": "cd5c",
	"./Humanist/1.png": "6161",
	"./Humanist/10.png": "222f",
	"./Humanist/11.png": "0b4e",
	"./Humanist/12.png": "f391",
	"./Humanist/13.png": "42d2",
	"./Humanist/14.png": "592e",
	"./Humanist/15.png": "e1d8",
	"./Humanist/16.png": "cdc5",
	"./Humanist/17.png": "d5bb",
	"./Humanist/18.png": "0bc0",
	"./Humanist/19.png": "a9ef",
	"./Humanist/2.png": "df1a",
	"./Humanist/20.png": "8c4a",
	"./Humanist/21.png": "b0b7",
	"./Humanist/22.png": "6822",
	"./Humanist/23.png": "3ac4",
	"./Humanist/24.png": "aac6",
	"./Humanist/25.png": "f7ac",
	"./Humanist/25_1.png": "ade5",
	"./Humanist/26.png": "891a",
	"./Humanist/27.png": "152b",
	"./Humanist/3.png": "1802",
	"./Humanist/4.png": "8226",
	"./Humanist/5.png": "609d",
	"./Humanist/6.png": "7a65",
	"./Humanist/7.png": "3dea",
	"./Humanist/8.png": "ce7e",
	"./Humanist/9.png": "6910",
	"./Humanist/BASKET_552.png": "5e39",
	"./Humanist/Humanist.png": "6b67",
	"./Humanist/Humanist_old.png": "aef6",
	"./Humanist/VA_logo.png": "b916",
	"./Humanist/end_screen.png": "20f6",
	"./Humanist/two_people.svg": "7cee",
	"./HumanistEcoSpark/03.png": "4e1b",
	"./HumanistEcoSpark/1.png": "73c2",
	"./HumanistEcoSpark/10.png": "2a49",
	"./HumanistEcoSpark/11.png": "f639",
	"./HumanistEcoSpark/12.png": "d92b",
	"./HumanistEcoSpark/13.png": "ebfb",
	"./HumanistEcoSpark/14.png": "af11",
	"./HumanistEcoSpark/15.png": "38ca",
	"./HumanistEcoSpark/16.png": "67dc",
	"./HumanistEcoSpark/17.png": "f2ec",
	"./HumanistEcoSpark/18.png": "4e2e",
	"./HumanistEcoSpark/19.png": "eb27",
	"./HumanistEcoSpark/2.png": "1fc6",
	"./HumanistEcoSpark/20.png": "2e77",
	"./HumanistEcoSpark/21.png": "1b14",
	"./HumanistEcoSpark/22.png": "edd9",
	"./HumanistEcoSpark/23.png": "57f9",
	"./HumanistEcoSpark/24.png": "0b91",
	"./HumanistEcoSpark/25.png": "d1f0",
	"./HumanistEcoSpark/25_1.png": "0c8e",
	"./HumanistEcoSpark/26.png": "e4dc",
	"./HumanistEcoSpark/27.png": "abef",
	"./HumanistEcoSpark/3.png": "c8c7",
	"./HumanistEcoSpark/4.png": "a3ef",
	"./HumanistEcoSpark/5.png": "0785",
	"./HumanistEcoSpark/6.png": "724c",
	"./HumanistEcoSpark/7.png": "2c7d",
	"./HumanistEcoSpark/8.png": "faf3",
	"./HumanistEcoSpark/9.png": "1aa8",
	"./HumanistEcoSpark/BASKET_552.png": "b982",
	"./HumanistEcoSpark/Humanist.png": "a8a1",
	"./HumanistEcoSpark/Humanist_old.png": "3e43",
	"./HumanistEcoSpark/VA_logo.png": "117c",
	"./HumanistEcoSpark/end_screen.png": "55a1",
	"./HumanistEcoSpark/two_people.svg": "2662",
	"./Left_arrow_button.svg": "ba99",
	"./PRN1/49.png": "b082",
	"./PRN1/50-51.png": "ef9c",
	"./PRN1/52.png": "eb85",
	"./PRN1/53.png": "0547",
	"./PRN1/54.png": "6399",
	"./PRN1/55.png": "5ccd",
	"./PRN1/56.png": "a4c7",
	"./PRN1/57.png": "2f38",
	"./PRN1/58.png": "6cf8",
	"./PRN1/59.png": "b0c7",
	"./PRN1/60-61-2.png": "e208",
	"./PRN1/60-61.png": "8881",
	"./PRN1/61.png": "03d5",
	"./PRN1/62-2.png": "2e42",
	"./PRN1/62.png": "9ab2",
	"./PRN1/63.png": "af71",
	"./PRN1/64.png": "01dc",
	"./PRN1/65.png": "0074",
	"./PRN1/66.png": "42ea",
	"./PRN1/66_1.png": "13b3",
	"./PRN1/67.png": "2c08",
	"./PRN1/68.png": "da8a",
	"./PRN1/69.png": "0ddc",
	"./PRN1/70.png": "47d8",
	"./PRN1/Greta.png": "dcea",
	"./PRN1/VA_logo.png": "9709",
	"./PRN1/end_screen.png": "a012",
	"./PRN1/front-panel.png": "2362",
	"./PRN1/spark_basket_01.png": "1d76",
	"./PRN1/spark_basket_02.png": "44a4",
	"./PRN1/spark_basket_03_opcion_2.png": "63ca",
	"./PRN1/spark_basket_04.png": "eb6c",
	"./PRN1/two_people.svg": "e5ce",
	"./Right_arrow_button.svg": "33ce",
	"./arrowdown.svg": "8eec",
	"./arrowup.svg": "f59b",
	"./bg.png": "dc97",
	"./build_faded.png": "3738",
	"./build_gray.png": "f415",
	"./build_selected.png": "2102",
	"./empty.svg": "0afe",
	"./end_build.png": "f45c",
	"./end_setup.png": "b35b",
	"./last_screen.gif": "6ce8",
	"./last_screen/Ca-T200.gif": "11ce",
	"./last_screen/Ca-T600.gif": "7eda",
	"./last_screen/Ca-studio.gif": "ba61",
	"./last_screen/ChSimplified-T200.gif": "9b0e",
	"./last_screen/ChSimplified-T600.gif": "27fb",
	"./last_screen/ChSimplified-studio.gif": "86d1",
	"./last_screen/ChTradicional-T200.gif": "424b",
	"./last_screen/ChTradicional-T600.gif": "33ac",
	"./last_screen/ChTradicional-studio.gif": "1f76",
	"./last_screen/De-T200.gif": "888c",
	"./last_screen/De-T600.gif": "9c5c",
	"./last_screen/De-studio.gif": "c8cb",
	"./last_screen/En-Studio.gif": "8bd4",
	"./last_screen/En-T200-T600.gif": "080e",
	"./last_screen/En-T200.gif": "32f6",
	"./last_screen/En-T600.gif": "f9ff",
	"./last_screen/End_screen.gif": "9a84",
	"./last_screen/Es-T200.gif": "0679",
	"./last_screen/Es-T600.gif": "9bb2",
	"./last_screen/Es-studio.gif": "845d",
	"./last_screen/Fr-T200.gif": "9e94",
	"./last_screen/Fr-T600.gif": "7968",
	"./last_screen/Fr-studio.gif": "d887",
	"./last_screen/It-T200.gif": "96e5",
	"./last_screen/It-T600.gif": "d2f2",
	"./last_screen/It-studio.gif": "dd62",
	"./last_screen/Ja-T200.gif": "e42b",
	"./last_screen/Ja-T600.gif": "4cf0",
	"./last_screen/Ja-studio.gif": "8e2f",
	"./last_screen/Ko-T200.gif": "1d4c",
	"./last_screen/Ko-T600.gif": "74c6",
	"./last_screen/Ko-studio.gif": "65d1",
	"./last_screen/Last image OOBE English.png": "d958",
	"./last_screen/Last image OOBE French.png": "9c28",
	"./last_screen/Last image OOBE German.png": "d11b",
	"./last_screen/Last image OOBE Italian.png": "2f44",
	"./last_screen/Last image OOBE Japanese.png": "b83e",
	"./last_screen/Last image OOBE Korean.png": "ce76",
	"./last_screen/Last image OOBE Polish.png": "ef2b",
	"./last_screen/Last image OOBE Portuguese.png": "71f5",
	"./last_screen/Last image OOBE Simplified Chinese.png": "93e1",
	"./last_screen/Last image OOBE Spanish.png": "492d",
	"./last_screen/Last image OOBE Traditional Chinese.png": "2be6",
	"./last_screen/Nl-Studio.gif": "52c82",
	"./last_screen/Nl-T200.gif": "16e7",
	"./last_screen/Nl-T600.gif": "90af",
	"./last_screen/Pl-T200.gif": "c177",
	"./last_screen/Pl-T600.gif": "b39a",
	"./last_screen/Pl-studio.gif": "3aa7",
	"./last_screen/Pt-T200.gif": "0f71",
	"./last_screen/Pt-T600.gif": "4065",
	"./last_screen/Pt-studio.gif": "12c1",
	"./last_screen/Ru-T200.gif": "dccb",
	"./last_screen/Ru-T600.gif": "fb78",
	"./last_screen/Ru-studio.gif": "3df7",
	"./last_screen/Web_App_Spanish_image.png": "35ec",
	"./left_arrow_gray.svg": "b71b",
	"./left_blue.png": "ad73",
	"./left_gray.png": "2118",
	"./printer2.png": "ba89",
	"./right_arrow_gray.svg": "1476",
	"./right_blue.png": "992b",
	"./right_gray.png": "d32a",
	"./setup_selected.png": "1e44",
	"./setup_unselected.png": "3440",
	"./surveyicons/andry--default.svg": "74c7",
	"./surveyicons/andry--pressed.svg": "6e83",
	"./surveyicons/happy--default.svg": "b563",
	"./surveyicons/happy--pressed.svg": "6975",
	"./surveyicons/neutral--default.svg": "4b5b",
	"./surveyicons/neutral--pressed.svg": "3e7d",
	"./surveyicons/sad--default.svg": "8d14",
	"./surveyicons/sad--pressed.svg": "a36b",
	"./surveyicons/smile--default.svg": "ad5b",
	"./surveyicons/smile--pressed.svg": "97ce",
	"./verified.svg": "bbc0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";